<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type { FormKitNode } from '@formkit/core'
import type { FormAddressInput } from '~/composables/useForm'
import FormKitAddress from './kit/FormKitAddress.vue'

const props = defineProps<{
  data: FormAddressInput
}>()

const { t } = useI18n()
const { dt } = useDirectusTranslation()

const addressInputType = createInput(FormKitAddress, {
  props: ['placeholder'],
})

async function mustBeValidAddress(node: FormKitNode) {
  const data = await $fetch(`/server/address_valid`, {
    query: {
      id: (node.value as any).id,
    },
  })
  return data.valid
}
</script>

<template>
<FormKitLazyProvider config-file="true">

  <div>
    <FormKit
      :id="props.data.key"
      :type="addressInputType"
      :name="props.data.key"
      :label="dt(props.data.translations)?.label"
      :placeholder="dt(props.data.translations)?.placeholder"
      validation="required|mustBeValidAddress"
      :validation-rules="{
        mustBeValidAddress,
      }"
      :validation-messages="{
        mustBeValidAddress: t('form.location.invalid_address'),
      }"
    />
  </div>

</FormKitLazyProvider>
</template>

<style>

</style>
